import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20.678 17.154 18.16 15.7a.36.36 0 0 0-.496.135l-.454.787a.365.365 0 0 0 .133.498l2.518 1.454a.36.36 0 0 0 .495-.134l.454-.788a.367.367 0 0 0-.132-.498m-3.016-8.99a.364.364 0 0 0 .495.134l2.519-1.454a.365.365 0 0 0 .132-.498l-.452-.785a.363.363 0 0 0-.495-.135L17.343 6.88a.365.365 0 0 0-.133.498zm3.973 3.013h-2.923c-.2 0-.365.164-.365.365v.914c0 .2.164.365.365.365h2.923c.2 0 .365-.165.365-.365v-.914c0-.2-.164-.365-.365-.365M14.6 2.935a.7.7 0 0 0-.397.121L6.11 8.346H2.365c-.2 0-.365.164-.365.365v6.576c0 .2.164.365.365.365H6.11l8.093 5.29a.728.728 0 0 0 1.13-.612V3.668a.73.73 0 0 0-.732-.733"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }